import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import FeatureSection from './components/FeatureSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩国漫画无删减漫画下拉式-免费韩漫大全-韩漫网站',
            description: '韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，资源丰富多元，无广告干扰，让您享受纯净阅读时光。',
            url: 'http://jorjigsrp.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫大全',
              url: 'http://jorjigsrp.com/',
            },
            about: {
              '@type': 'Thing',
              name: '韩国漫画',
              description: '无删减韩国漫画下拉式免费韩漫大全',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedGrid />
          <FeatureSection />
          <TestimonialSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}